const DETECTION_STEP = 0
const INVESTIGATION_STEP = 1
const HIGH_RISK_STEP = 8
const AVALIATION_STEP = 2
const DETALING_STEP = 3
const TREATMENT_STEP = 4
const REPORTING_STEP = 7
const COMMUNICATION_STEP = 5
const LESSONS_LEARNED_STEP = 6

const STEPS = [
  DETECTION_STEP,
  INVESTIGATION_STEP,
  HIGH_RISK_STEP,
  AVALIATION_STEP,
  DETALING_STEP,
  TREATMENT_STEP,
  REPORTING_STEP,
  COMMUNICATION_STEP,
  LESSONS_LEARNED_STEP,
]

const DETECTION_ENUM = 'detection'
const INVESTIGATION_ENUM = 'investigation'
const HIGH_RISK_ENUM = 'high_risk'
const AVALIATION_ENUM = 'avaliation'
const DETALING_ENUM = 'detaling'
const TREATMENT_ENUM = 'treatment'
const REPORTING_ENUM = 'reporting'
const COMMUNICATION_ENUM = 'communication'
const LESSONS_LEARNED_ENUM = 'lessons_learned'

const DETECTION_LABEL = 'Detecção'
const INVESTIGATION_LABEL = 'Investigação'
const HIGH_RISK_LABEL = 'Alto Risco'
const AVALIATION_LABEL = 'Avaliação'
const DETALING_LABEL = 'Formulário ANPD'
const TREATMENT_LABEL = 'Tratamento'
const REPORTING_LABEL = 'Relatório'
const COMMUNICATION_LABEL = 'Comunicação'
const LESSONS_LEARNED_LABEL = 'Lições Aprendidas'

const STEPS_LIST = [
  { value: DETECTION_ENUM, name: DETECTION_LABEL },
  { value: INVESTIGATION_ENUM, name: INVESTIGATION_LABEL },
  { value: HIGH_RISK_ENUM, name: HIGH_RISK_LABEL },
  { value: AVALIATION_ENUM, name: AVALIATION_LABEL },
  { value: DETALING_ENUM, name: DETALING_LABEL },
  { value: TREATMENT_ENUM, name: TREATMENT_LABEL },
  { value: REPORTING_ENUM, name: REPORTING_LABEL },
  { value: COMMUNICATION_ENUM, name: COMMUNICATION_LABEL },
  { value: LESSONS_LEARNED_ENUM, name: LESSONS_LEARNED_LABEL },
]

const ENUMS_BY_STEP = {
  [DETECTION_STEP]: DETECTION_ENUM,
  [INVESTIGATION_STEP]: INVESTIGATION_ENUM,
  [HIGH_RISK_STEP]: HIGH_RISK_ENUM,
  [AVALIATION_STEP]: AVALIATION_ENUM,
  [DETALING_STEP]: DETALING_ENUM,
  [TREATMENT_STEP]: TREATMENT_ENUM,
  [REPORTING_STEP]: REPORTING_ENUM,
  [COMMUNICATION_STEP]: COMMUNICATION_ENUM,
  [LESSONS_LEARNED_STEP]: LESSONS_LEARNED_ENUM,
}

const LABELS = {
  [DETECTION_ENUM]: DETECTION_LABEL,
  [INVESTIGATION_ENUM]: INVESTIGATION_LABEL,
  [HIGH_RISK_ENUM]: HIGH_RISK_LABEL,
  [AVALIATION_ENUM]: AVALIATION_LABEL,
  [DETALING_ENUM]: DETALING_LABEL,
  [TREATMENT_ENUM]: TREATMENT_LABEL,
  [REPORTING_ENUM]: REPORTING_LABEL,
  [COMMUNICATION_ENUM]: COMMUNICATION_LABEL,
  [LESSONS_LEARNED_ENUM]: LESSONS_LEARNED_LABEL,
}

const ORDER_BY_ENUM = {
  [DETECTION_ENUM]: 0,
  [INVESTIGATION_ENUM]: 1,
  [HIGH_RISK_ENUM]: 2,
  [AVALIATION_ENUM]: 3,
  [DETALING_ENUM]: 4,
  [TREATMENT_ENUM]: 5,
  [REPORTING_ENUM]: 6,
  [COMMUNICATION_ENUM]: 7,
  [LESSONS_LEARNED_ENUM]: 8,
}

export default {
  ENUMS_BY_STEP,
  LABELS,
  STEPS,
  ORDER_BY_ENUM,
  STEPS_LIST,
  DETECTION_ENUM,
  INVESTIGATION_ENUM,
  HIGH_RISK_ENUM,
  AVALIATION_ENUM,
  DETALING_ENUM,
  TREATMENT_ENUM,
  REPORTING_ENUM,
  COMMUNICATION_ENUM,
  LESSONS_LEARNED_ENUM,
}
